import { Button } from '@repo/ui/components/button';
import { Input } from '@repo/ui/components/input';
import { Label } from '@repo/ui/components/label';
import { Check, Copy, Share2 } from 'lucide-react';

import { useShareInvite } from '@/hooks/use-share-invite';

interface InvitePartnerFormProps {
  inviteToken: string;
}

export function InvitePartnerForm({ inviteToken }: InvitePartnerFormProps) {
  const { inviteUrl, copied, handleCopy, handleShare } =
    useShareInvite(inviteToken);

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="invite-link">Link de convite</Label>
        <div className="flex gap-2">
          <Input
            id="invite-link"
            value={inviteUrl}
            readOnly
            className="font-mono text-sm"
          />
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={handleCopy}
            title="Copiar link"
          >
            {copied ? (
              <Check className="h-4 w-4 text-green-500" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </Button>
        </div>
        <p className="text-muted-foreground text-sm">
          Compartilhe esse link com seu amor para conectarem-se
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <Button onClick={handleShare} className="w-full">
          <Share2 className="mr-2 h-4 w-4" />
          Compartilhar convite
        </Button>
        <Button variant="outline" onClick={handleCopy} className="w-full">
          <Copy className="mr-2 h-4 w-4" />
          Copiar link
        </Button>
      </div>
    </div>
  );
}
